var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "krypton-tab-handler",
    attrs: { tabindex: "0" },
    on: { focus: _vm.onFocus },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }